<script>
import { of } from 'rxjs'
import { filter } from 'rxjs/operators'
export default {
  render(createElement) {
    const ref = this._self.$vnode.data.ref
    const getElementData = {
      tooltip: { tag: 'b-tooltip', data: this.getTooltipData },
      normal: { tag: 'b-collapse', data: this.getCollapseData },
    }

    let visible = false
    of(...this.data)
      .pipe(filter(({ link: { isActive } }) => isActive))
      .subscribe(() => {
        visible = true
      })

    const elementData = getElementData[this.type].data(ref, visible)

    return createElement(getElementData[this.type].tag, elementData, [
      createElement(
        'b-list-group',
        this.data.map(item => {
          return createElement(
            'b-list-group-item',
            {
              class: {
                active: item.link.isActive,
              },
              attrs: {
                tag: 'a',
                'data-list-role': 'subItem',
              },
              on: {
                click: $event => this.handleItemClick($event, item.link),
              },
            },
            item.label
          )
        })
      ),
    ])
  },
  props: {
    target: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      tooltip: {
        customClass: ['white-itens', 'tooltip-sidebar-menu', 'submenu'],
      },
    }
  },
  methods: {
    getCollapseData(ref, visible) {
      return {
        ref,
        class: {
          submenu: true,
        },
        attrs: {
          visible,
          'data-list-role': 'collapse',
          'data-list-parent': this.target,
          id: ref,
        },
      }
    },
    getTooltipData(ref) {
      return {
        ref,
        class: {
          submenu: true,
        },
        attrs: {
          triggers: [],
          target: this.target,
          container: 'sidebarMenu',
          placement: 'bottom',
          'data-list-role': 'tooltip',
          'data-list-parent': this.target,
          id: ref,
        },
      }
    },
    addCustomClass(el) {
      if (!el) return
      const tooltip = el.closest('.tooltip')
      tooltip.setAttribute('data-list-parent', this.target)
      this.tooltip.customClass.forEach(customClass =>
        tooltip.classList.add(customClass)
      )
    },
    toggleOpen() {
      const toggleOptions = {
        tooltip: this.toggleTooltip,
        normal: this.toggleCollapse,
      }

      toggleOptions[this.type]()
    },
    toggleCollapse() {
      this.$root.$emit('bv::toggle::collapse', this._self.$vnode.data.ref)
    },
    toggleTooltip() {
      this.open = !this.open
      this.open
        ? this.$refs[this._self.$vnode.data.ref].$emit('open')
        : this.$refs[this._self.$vnode.data.ref].$emit('close')
      this.open &&
        [...document.querySelectorAll('#sidebarMenu > .tooltip')].forEach(el =>
          this.addCustomClass(el)
        )
      this.open && this.listenForTooltipHidden()
    },
    listenForTooltipHidden() {
      this.$children[0].$on('hidden', () => {
        this.open = false
      })
    },
    handleItemClick($event, link) {
      this.$router.push(link)
    },
  },
}
</script>
